/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".animate-flicker[_ngcontent-%COMP%]{background-color:#f4f3f4;border-radius:1rem;margin:.3rem}.line[_ngcontent-%COMP%]{display:inline-block}.animate-flicker[_ngcontent-%COMP%]{-webkit-animation:flickerAnimation 1s infinite;animation:flickerAnimation 1s infinite}.fa-circle[_ngcontent-%COMP%]{color:#f4f3f4}.circumference[_ngcontent-%COMP%]{border:#f4f3f4;background-color:transparent!important;border-width:.5rem;border-style:solid;display:inline-block}@-webkit-keyframes flickerAnimation{0%{opacity:0}50%{opacity:1}to{opacity:0}}@keyframes flickerAnimation{0%{opacity:0}50%{opacity:1}to{opacity:0}}@-webkit-keyframes fadeIn{0%{opacity:0}to{opacity:1}}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}"];
export { styles as styles };
//# sourceMappingURL=dummy-loading-content.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/shared/dummy-loading-content/dummy-loading-content.component.scss.shim.ngstyle.js
// module id = 1374
// module chunks = 27 28 29